import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import {getOnBoardingData} from "../services/awsHandler";

export default function InputForms(props) {
  const { t } = useTranslation();
  const {
    assignee,
    setAssignee,
    appName,
    setAppName,
    secondAppName,
    setSecondAppName,
    thirdAppName,
    setThirdAppName,
    businessEmail,
    setBusinessEmail,
    setMainColor,
    setTextColor,
    setSecondaryColor,
    mainColor,
    secondaryColor,
    textColor
  } = props;
  const [onBoardingMembers, setOnBoardingMembers] = useState(null)

  useEffect(() => {
    fetchOnBoardingMembers()
  }, []);

  useEffect(() => {
    if(onBoardingMembers && onBoardingMembers.length) {
      setAssignee(onBoardingMembers[0])
    }
  }, [onBoardingMembers]);

  const fetchOnBoardingMembers = async () => {
    const res = await getOnBoardingData()
    setOnBoardingMembers(res)
  }

  const handleAssigneeChange = (event) => {
    const obMember = onBoardingMembers.find(member => member.mail === event.target.value);
    setAssignee(obMember);
  };

  return (
    <div className="form-wrapper">
      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>{t('teamInputTitle')}</label>
          <select className="field-control" onChange={handleAssigneeChange} value={assignee?.mail}>
            {onBoardingMembers?.map((member) => (<option key={member.mail} value={member.mail}>{member.mail} - {member.name}</option>))}
          </select>
        </div>
      </div>
      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>{t('businessOwnerInputTitle')}</label>
          <input
            type="text"
            value={businessEmail}
            onChange={(e) => {
              setBusinessEmail(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>{t('appNameInputTitle')}</label>
          <input
            type="text"
            value={appName}
            onChange={(e) => {
              setAppName(e.target.value);
            }}
          />
          <span className="small">{t('appNameInputPlaceholder')}</span>
        </div>
      </div>
      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>
            {t('appNameSecondInputTitle')}
          </label>
          <input
            type="text"
            value={secondAppName}
            onChange={(e) => {
              setSecondAppName(e.target.value);
            }}
          />
          <span className="small">{t('appNameSecondInputPlaceholder')}</span>
        </div>
      </div>
      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>{t('appNameThirdInputTitle')}</label>
          <input
            type="text"
            value={thirdAppName}
            onChange={(e) => {
              setThirdAppName(e.target.value);
            }}
          />
          <span className="small">{t('appNameThirdInputPlaceholder')}</span>
        </div>
      </div>

      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>{t('appMainColorInputTitle')}</label>
          <div className="container-color">
            <input
              type="color"
              id="main-color-picker"
              value={mainColor}
              onChange={(e) => {
                setMainColor(e.target.value);
              }}
            />
            <input
              className="border-none"
              type="text"
              value={mainColor}
              onChange={(e) => {
                setMainColor(e.target.value);
              }}
            />
            <span id="main-color-value"></span>
          </div>
          <span className="small">{t('appMainColorInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label>{t('appSecondaryColorInputTitle')}</label>
          <div className="container-color">
            <input
              type="color"
              id="secondary-color-picker"
              value={secondaryColor}
              onChange={(e) => setSecondaryColor(e.target.value)}
            />
            <input
              type="text"
              className="border-none"
              value={secondaryColor}
              onChange={(e) => setSecondaryColor(e.target.value)}
            />
            <span id="secondary-color-value"></span>
          </div>
          <span className="small">{t('appSecondaryColorInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label>{t('appTextColorInputTitle')}</label>
          <select className="field-control" value={textColor} onChange={(e) => {
            setTextColor(e.target.value);
          }}>
            <option>צבע טקסט</option>
            <option value="#ffffff">White - #ffffff</option>
            <option value="#000000">Black - #000000</option>
          </select>
        </div>
      </div>
    </div>
  );
}
